












import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import DocumentSheet from '@/components/DocumentSheet.vue'  // @ is an alias to /src
import { Receipt, Invoice } from '@/services/models'

@Component({
  components: {
    DocumentSheet,
  },
})
export default class ReceiptComponent extends Vue {

  @Action('firestore/fetchReceipts')
  private fetchReceipts!: () => Promise<void>

  @Action('firestore/fetchInvoices')
  private fetchInvoices!: () => Promise<void>

  @Action('firestore/issueReceipt')
  private issueReceipt!: (args: { invoice: Invoice, issueDate: Date }) => Promise<void>

  @Getter('firestore/receipt')
  private readReceipt!: (receiptId: string) => Receipt|undefined

  @Getter('firestore/invoice')
  private readInvoice!: (invoiceId: string) => Invoice|undefined

  private issuingReceipt: boolean|Error = true

  private get receipt(): Receipt|undefined {
    return this.readReceipt(this.receiptId)
  }

  private get receiptId(): string {
    return this.$route.params.receipt_id
  }

  public mounted() {
    this.fetchReceipts()
      .then(() => {
        this.issuingReceipt = true
        return this.issueReceiptIfNotFound()
      })
      .then(() => {
        this.issuingReceipt = false
      })
      .catch((error) => {
        this.issuingReceipt = error
      })
  }

  // Move this to firestore action?
  private async issueReceiptIfNotFound(): Promise<void> {
    if (this.receipt) {
      return
    }
    await this.fetchInvoices()
    const invoice = this.readInvoice(this.receiptId)
    if (!invoice) {
      throw new Error(`Unknown or invalid invoiceId: ${this.receiptId}`)
    }
    await this.issueReceipt({ invoice, issueDate: new Date() })
    await this.fetchReceipts()
  }
}
